import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

import {
  IAuthData,
  IBasicEntity,
  IGenericResponse,
  IResetContent,
  IResetPasswordParams,
  User,
} from "@/services/interfaces";
import { Storage } from "@/services/interfaces/enums";
import requestWrapper from "@/services/api/utils/requestWrapper";
import { cartModule } from "@/plugins/store-accessors";
import { copy } from "@/services/utils";

@Module({
  name: "personal",
  namespaced: true,
})
export default class Personal extends VuexModule {
  user: User | null = null;
  savedUser: User | null = null;
  resetContent: IResetContent = {
    h1: "Установить пароль",
    message: "",
  };
  error: string | null = null;
  isLoginModalShown = false;
  loginMessage = "";

  get isAuthorized() {
    return !!this.user?.name;
  }
  get getUserName() {
    return this.user?.name;
  }
  get getUser() {
    return this.user;
  }
  get getSavedUser() {
    return this.savedUser;
  }
  get getError() {
    return this.error;
  }
  get getResetContent() {
    return this.resetContent;
  }
  get getMessage() {
    return this.loginMessage;
  }
  get getModalState() {
    return this.isLoginModalShown;
  }

  @Mutation
  showLoginModal(message: string = "") {
    this.isLoginModalShown = true;
    this.loginMessage = message;
  }

  @Mutation
  hideLoginModal() {
    this.isLoginModalShown = false;
    this.loginMessage = "";
  }

  @Mutation
  setActiveUser(user: User | null) {
    this.user = user;
    user
      ? localStorage.setItem(Storage.USER, JSON.stringify(user))
      : localStorage.removeItem(Storage.USER);
  }

  @Mutation
  setSavedUser(user: User | null) {
    this.savedUser = user;
    user
      ? localStorage.setItem(Storage.SAVED_USER, JSON.stringify(user))
      : localStorage.removeItem(Storage.SAVED_USER);
  }

  @Mutation
  setResetContent(res: IGenericResponse) {
    const content: IResetContent = {
      h1: "",
      message: "",
    };
    if (!res.errors) {
      const { data, meta } = res.data;
      if (meta && meta.h1) content.h1 = meta.h1;
      if (data.message) content.message = data.message;
      if (data.inputs) content.inputs = true;
      if (data.button) content.button = data.button;
    }
    this.resetContent = content;
  }

  @Mutation
  setToken(token: string) {
    localStorage.setItem(Storage.TOKEN, token);
  }

  @Mutation
  setRefreshToken(refresh: string) {
    localStorage.setItem(Storage.REFRESH_TOKEN, refresh);
  }

  @Mutation
  logout() {
    localStorage.removeItem(Storage.USER);
    localStorage.removeItem(Storage.TOKEN);
    localStorage.removeItem(Storage.REFRESH_TOKEN);
    localStorage.removeItem(Storage.SAVED_USER);
    localStorage.removeItem(Storage.SAVED_TOKEN);
    localStorage.removeItem(Storage.SAVED_REFRESH_TOKEN);
    this.user = null;
    this.savedUser = null;
    this.error = null;
  }

  @Mutation
  logoutAsUser() {
    this.error = null;
    this.user = copy(this.savedUser);
    localStorage.setItem(Storage.USER, JSON.stringify(this.user));

    this.savedUser = null;
    localStorage.removeItem(Storage.SAVED_USER);

    const token = localStorage.getItem(Storage.SAVED_TOKEN);
    const refresh = localStorage.getItem(Storage.SAVED_REFRESH_TOKEN);

    token && localStorage.setItem(Storage.TOKEN, token);
    refresh && localStorage.setItem(Storage.REFRESH_TOKEN, refresh);

    localStorage.removeItem(Storage.SAVED_TOKEN);
    localStorage.removeItem(Storage.SAVED_REFRESH_TOKEN);
  }

  @Action
  forceLogout() {
    this.logout();
    this.showLoginModal();
  }

  @Action
  login(data: IAuthData = {}) {
    const { token, name, refresh } = data;

    token && this.setToken(token);
    refresh && this.setRefreshToken(refresh);
    name && this.setActiveUser({ name, phone: "" });
    this.hideLoginModal();
  }

  @Action
  async getResetStatus(url: string): Promise<IGenericResponse> {
    const res = await requestWrapper({
      method: "GET",
      url: "/api" + url,
    });
    if (!res.errors) {
      this.setResetContent(res);
    }
    return res;
  }

  @Action
  async sendNewPassword({
    data,
    url,
  }: IResetPasswordParams): Promise<IGenericResponse> {
    const res = await requestWrapper({
      method: "POST",
      url,
      data,
    });
    if (!res.errors) {
      this.setResetContent(res);
      cartModule.getCart();

      if (res.data && res.data.meta && res.data.meta.auth) {
        this.login(res.data.meta.auth);
      }
    }
    return res;
  }
}
